import type { CommentableContentObject } from 'models';
import type { ReactNode, RefObject } from 'react';
import { Col, Divider, type InputRef, Modal, type RichTextEditorBase, Row } from 'ui';
import { CommentsWrapper } from '../comments-wrapper';
import { useContentObjectModalTitle } from './hooks';

type P = {
  commentFormContainerRef?: RefObject<HTMLDivElement | null>;
  contentObject: CommentableContentObject;
  contentObjectRenderer: ReactNode;
  editorRef?: RefObject<null | RichTextEditorBase>;
  inputRef?: RefObject<InputRef | null>;
  isOpened: boolean;
  onClose: () => void;
  title: string;
};

// TODO: After the feed is reworked, check if it's possible to send only the content object ID instead of these properties
const ContentObjectModal = ({
  commentFormContainerRef,
  contentObject,
  contentObjectRenderer,
  editorRef,
  inputRef,
  isOpened,
  onClose,
  title,
}: P) => {
  const modalTitle = useContentObjectModalTitle({ title, type: contentObject.type });

  return (
    <Modal
      afterOpenChange={(open) => {
        if (open) {
          // TODO: This is hack for scroll to comment form after modal animation is done
          // will be removed when modal become scrollable again
          commentFormContainerRef?.current?.scrollIntoView({ behavior: 'smooth' });
        }
      }}
      className="content-object-modal"
      isOpened={isOpened}
      maskClosable={false}
      onCancel={onClose}
      title={modalTitle}
      width="medium"
    >
      <Modal.HugContent>
        <Row gutter={[0, 'ms']}>
          <Col span={24}>
            <Row gutter={[0, 'ms']}>
              <Col span={24}>{contentObjectRenderer}</Col>
              <Col span={24}>
                <Divider marginNone />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <CommentsWrapper
              commentFormContainerRef={commentFormContainerRef}
              contentObject={contentObject}
              editorRef={editorRef}
              initialMode="input"
              inputRef={inputRef}
              // eslint-disable-next-line react-hooks/refs -- TODO: fix
              scrollOnMount={Boolean(commentFormContainerRef)}
            />
          </Col>
        </Row>
      </Modal.HugContent>
    </Modal>
  );
};

export default ContentObjectModal;
